import { Component, Input } from '@angular/core';

import { ButtonComponent } from '../button/button.component';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-blog-post-card',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './blog-post-card.component.html',
  styleUrl: './blog-post-card.component.scss',
})
export class BlogPostCardComponent {
  @Input() card: any;
  constructor(private navigationService: NavigationService) {}

  onButtonClick = () => {
    const link = this.card.read_more_button.link;
    if (link.startsWith('http')) {
      window.open(link, '_blank');
    } else {
      this.navigationService.navigateToPath(link);
    }
  };
}
